import { init } from "./script/carousel.ts";
import { drawerToggle } from "./script/drawer.ts";

/* When the user scrolls down, hide the navbar. When the user scrolls up, show the navbar */
let prevScrollpos = window.pageYOffset;
let topnav = document.querySelector("#topnav")! as HTMLElement;

addEventListener("scroll", () => {
  let currentScrollPos = window.pageYOffset;
  // let navsize = document.querySelector("nav")!.offsetHeight;
  if (prevScrollpos > currentScrollPos) {
    topnav.style.top = "0";
  } else {
    topnav.style.top = "-" + topnav.clientHeight + "px";
  }
  prevScrollpos = currentScrollPos;
}
  , true);

let drawerButton = document.querySelector("#menu")!;
drawerButton.addEventListener("click", drawerToggle);

let drawer = document.querySelector("#drawer")! as HTMLElement;
drawer.style.top = "" + topnav.clientHeight + "px";
drawer.style.right = "-" + drawer.clientWidth + "px";

let drawerButtons = document.querySelectorAll(".drawer-buttons");
for (let button of drawerButtons) {
  button.addEventListener("click", drawerToggle);
}

init();
